import styled from 'styled-components'

export const ExpandableWrapper = styled.div`
    height: auto;
    overflow: hidden;
    transition: height 0.3s ease-out;
`
